import request from '@/api/clients/portal-client'

export function translate({ text, fromLang, toLang, code }) {
  return request({
    url: '/ksai/translate',
    method: 'post',
    data: { text, fromLang, toLang, code },
    timeout: 600000
  })
}

export function splitVideo({ url, code }) {
  return request({
    url: '/ksai/split',
    method: 'post',
    data: { url, code },
    timeout: 600000
  })
}

export function geminiTts(data) {
  return request({
    url: '/ksai/geminiTts',
    method: 'post',
    data,
    timeout: 600000
  })
}

export function removeSubtitle({ url, code, areaArray }) {
  return request.post(
    '/ksai/removeSubtitle',
    { url, code, areaArray },
    {
      headers: { 'Content-Type': 'application/json' },
      timeout: 6000000
    }
  )
}

export function openaiVideoAnalysis(data) {
  return request({
    url: '/ksai/openaiVideoAnalysis',
    method: 'post',
    data,
    timeout: 600000
  })
}

export function audioGetSrt({ url }) {
  return request({
    url: '/ksai/audioGetSrt',
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: { url },
    timeout: 600000
  })
}

export function deductPower(power, code) {
  return request({
    url: '/ksai/deductPower',
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: { power, code },
    timeout: 600000
  })
}

export function deductPowerDirect(power) {
  return request({
    url: '/ksai/deductPowerDirect',
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: { power },
    timeout: 600000
  })
}

export function geminiVideoParse(url) {
  return request({
    url: '/ksai/geminiVideoParse',
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: { url },
    timeout: 600000
  })
}

export function parseTemplateVideo(url) {
  return request({
    url: '/ksai/parseTemplateVideo',
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: { url },
    timeout: 600000
  })
}
